import numbro from 'numbro'

export const formatDollarAmount = (num: string | number | null | undefined, digits = 3, round = false) => {
  if (typeof num === 'string') num = Number(num)
  if (num === 0) return '$0'
  if (!num) return '-'
  if (num < 0.001 && digits <= 3) {
    return '<$0.001'
  }

  return numbro(num)
    .formatCurrency({
      average: round,
      mantissa: num > 1000 ? 2 : digits,
      totalLength: 4,
      thousandSeparated: true,
      abbreviations: {
        million: 'M',
        billion: 'B',
        trillion: 'T',
      },
    })
    .replace('m', 'M')
    .replace('b', 'B')
    .replace('t', 'T')
}
